export interface BundleReference {
  componentSkuId?: string | null;
  componentProductGroupId?: string | null;
}

export interface CatalogSkuForRelevance {
  skuId: string;
  units?: number | null;
  revenue?: number | null;
  components?: readonly BundleReference[] | null;
}

export interface CatalogProductForRelevance {
  id: string;
  skus: readonly CatalogSkuForRelevance[];
}

export interface BundleReferenceIndex {
  skuIds: Set<string>;
  productGroupIds: Set<string>;
}

/**
 * A component of a sold bundle still needs categorization and exact cost even
 * when it has never sold by itself. Keep only those referenced dormant SKUs;
 * unrelated old catalog clutter remains hidden until it sells.
 */
export function bundleReferenceIndex(
  products: readonly CatalogProductForRelevance[],
): BundleReferenceIndex {
  const skuIds = new Set<string>();
  const productGroupIds = new Set<string>();
  for (const product of products) {
    for (const sku of product.skus) {
      for (const component of sku.components ?? []) {
        if (component.componentSkuId) skuIds.add(component.componentSkuId);
        if (component.componentProductGroupId) productGroupIds.add(component.componentProductGroupId);
      }
    }
  }
  return { skuIds, productGroupIds };
}

export function skuNeedsProductSetup(
  sku: CatalogSkuForRelevance,
  productGroupId: string | null,
  references: BundleReferenceIndex,
): boolean {
  return (sku.units ?? 0) > 0
    || (sku.revenue ?? 0) > 0
    || references.skuIds.has(sku.skuId)
    || (productGroupId !== null && references.productGroupIds.has(productGroupId));
}
